// Whether the stage panel is hidden: while a puzzle hides the moves from its
// position on (Scoresheet visibility's `hideFrom`), the stage's sections,
// the "Blunders and misses" rows first, would give the answer away, so the
// panel and the stage tabs' strip above it are hidden (display none, out of
// the tab order) until the puzzle is solved, shown or left, and the right
// column shows only the puzzle card and the Learn card. Until 2026-10-12 they
// were dimmed and inert instead. The selected tab stays. Pure, tested.

/** True while a Scoresheet visibility constraint hides moves. */
export function isHidden(scoresheet: { hideFrom?: number }): boolean {
  return scoresheet.hideFrom !== undefined;
}

/**
 * The event that hides the stage tabs' strip and its region with the panel,
 * or shows them again: the strip is the layout's (`layout.tabsHidden`), so
 * the whole right column under the puzzle card is gone until the puzzle
 * ends; the selected tab stays as it is.
 */
export function tabsHidden(slot: string, scoresheet: { hideFrom?: number }): { slot: string; hidden: boolean } {
  return { slot, hidden: isHidden(scoresheet) };
}
